import ForgotPassword from 'pages/auth/ForgotPassword'
import ResetPassword from 'pages/auth/ResetPassword'
import Login from 'pages/Login'
import { HomeRedirect } from './HomeRedirect'

const MainRoutes = {
  // All common routes
  path: '/',
  children: [
    {
      path: '/',
      element: <Login />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/hr-login',
      element: <Login />
    },
    {
      path: '/accountant-login',
      element: <Login />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/forgot-password-hr',
      element: <ForgotPassword />
    },
    {
      path: '/forgot-password-accountant',
      element: <ForgotPassword />
    },
    {
      path: '/reset-password/:resetToken',
      element: <ResetPassword />
    },
    {
      path: '/reset-password/hr-login/:resetToken',
      element: <ResetPassword />
    },
    {
      path: '/reset-password/accountant-login/:resetToken',
      element: <ResetPassword />
    },
    {
      path: '*',
      element: <HomeRedirect to='/' />
    }
  ]
}

export default MainRoutes
